export const BI_LOGGER_ACTION_NAMES = {
  EVENT: 'BI_LOGGER_ACTION_NAMES__EVENT',
};
